<template>
  <div>
<!--    <div v-if="bgc === 'black'" class="h-footer black">-->
<!--      {{ content }}-->
<!--    </div>-->
<!--    <div v-else class="h-footer">-->
<!--      {{ content }}-->
<!--    </div>-->
    <div style="width:400px;margin:0 auto; padding:30px 0;">
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" class="container"><span style="float:left;height:20px;line-height:20px;margin: 0px 5px 0px 5px; color:#939393;">{{content}}</span><img src="../../assets/batb.png" style="float:left;"/><span style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">鲁公网安备 37069102000256号</span ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myFooter',
  props: {
    // 页脚样式 black表适页脚是黑色背景 空为白色背景
    bgc: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      content: "鲁ICP备2023018757号-3"
    }
  }

}
</script>
<style scoped>
.h-footer {
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 1);
  color: rgba(51, 51, 51, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed;
    bottom: 0;
    left: 0; */
}

.black {
  height: 50px;
  background: black;
  color: rgba(255, 255, 255, 1);
}

.container {
  display: flex;
  align-items: center; /* 垂直居中 */
  text-decoration:none;
  height:20px;
  line-height:20px;
}
.container span {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue